<template>
  <div class="main">
    <Notifications />
    <router-view></router-view>
  </div>
</template>

<script>
import Notifications from '../components/Notifications.vue'
import bridge from '@open-condo/bridge'
import ServiceData from 'Mixins/ServiceData.js'

export default {
  name: 'App',
  components: { Notifications },
  mixins: [ServiceData],
  data() {
    return {
      resizeObserver: null,
      resizeTimeoutId: null,
      lastSentHeight: null,
    }
  },
  async created() {
    // await this.getEnvironment()
  },
  mounted() {
    this.resizeObserver = new ResizeObserver(entries => {
      if (entries && entries.length) {
        const clientHeight = entries[0].target.clientHeight + 100

        if (this.resizeTimeoutId) {
          clearTimeout(this.resizeTimeoutId)
        }

        this.resizeTimeoutId = setTimeout(() => {
          if (this.lastSentHeight === clientHeight) {
            return
          }

          this.lastSentHeight = clientHeight

          bridge
            .send('CondoWebAppResizeWindow', {
              height: clientHeight,
            })
            .catch(error => {
              if (error?.errorReason !== 'TIMEOUT_REACHED') {
                console.warn('Resize event failed:', error)
              }
            })
        }, 150)
      }
    })

    this.resizeObserver.observe(document.body)
  },
  beforeUnmount() {
    if (this.resizeTimeoutId) {
      clearTimeout(this.resizeTimeoutId)
      this.resizeTimeoutId = null
    }

    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
body {
  margin: 0px;
  padding: 0px;
}

* {
  font-family: 'Open Sans', sans-serif;
  font-style: normal;
  font-size: $font-size-lg;
  font-weight: $font-weight-md;
}

.main {
  position: relative;
  margin: $space-xxl;
}
</style>
